import { getQueryClient } from "@/services/get-query-client";

export default async function saveSessionId<T>(id: string): Promise<T> {
  const queryClient = getQueryClient();
  return await queryClient.fetchQuery({
    queryKey: [id],
    queryFn: async () => {
      const embedderOrigin = window.location.href;
      const response = await fetch("/api/session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ session_id: id, origin: embedderOrigin }),
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch settings: ${response.status}`);
      }
      return response.json();
    },
  });
}
